<div *ngIf="valid" [class]="cls" [matTooltip]="tooltip">
  <a *ngIf="url; else sourceTemplate" target="_blank" [href]="url">
    <ng-container [ngTemplateOutlet]="sourceTemplate"></ng-container>
  </a>
  <ng-template #sourceTemplate>
    <div class="source__abbr">{{ abbr }}</div>
    <div class="source__text" *ngIf="!compact">{{ text }}</div>
  </ng-template>
</div>
